import React from 'react';
import { Clock, CheckCircle2, AlertTriangle } from 'lucide-react';
import { gap, stamp } from '@/lib/hotelStay';

export function HotelWindowCheck({ sent, stay }) {
  if (!sent) {
    return (
      <div className="rounded-xl border border-white/10 p-4 text-sm text-gray-500" data-testid="hotel-window-empty">
        <div className="flex items-center gap-2 text-white mb-1"><Clock className="w-4 h-4 text-emerald-300" /> Cancellation window check</div>
        Send the cancellation to compare the hotel's receipt time with the free-cancellation deadline.
      </div>
    );
  }
  const at = sent.receipt.receivedAt;
  const inside = at <= stay.deadline;
  const Icon = inside ? CheckCircle2 : AlertTriangle;
  return (
    <div className={`rounded-xl border p-4 text-sm ${inside ? 'border-emerald-500/40' : 'border-amber-500/50'}`} data-testid="hotel-window-result">
      <div className="flex items-center gap-2 text-white mb-3"><Clock className="w-4 h-4 text-emerald-300" /> Cancellation window check</div>
      <div className="space-y-1 text-gray-300 mb-3">
        <div>Hotel's signed receipt: received <span className="font-mono text-xs" data-testid="hotel-received-at">{stamp(at)}</span></div>
        <div>Free cancellation ends: <span className="font-mono text-xs">{stamp(stay.deadline)}</span></div>
      </div>
      <div className={`flex gap-2 ${inside ? 'text-emerald-100/90' : 'text-amber-100/90'}`} data-testid="hotel-window-verdict">
        <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${inside ? 'text-emerald-400' : 'text-amber-400'}`} />
        <span>{inside
          ? `Inside the window. Received ${gap(stay.deadline - at)} before free cancellation ended. Under the hotel's own policy, no charge.`
          : `After the window. Received ${gap(at - stay.deadline)} after free cancellation ended. Under the hotel's own policy, a one-night charge may apply.`}</span>
      </div>
      <p className="text-xs text-gray-500 mt-3" data-testid="hotel-window-note">The record shows the timing. The hotel decides under its own policy. Kojiru makes no decision. Case {sent.caseRef} is shown in the receipt and timeline below.</p>
    </div>
  );
}
